'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _accordion = require('../../accordion');

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

var _breakpoints = require('../../../../utilities/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var ORGANISM_NAME = 'steps-accordion';

var renderHeadline = function renderHeadline(headline) {
  if (headline) {
    return _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'col-md-10 center-block text-xs-center' },
        _react2.default.createElement(
          _heading2.default,
          { level: '2', className: ORGANISM_NAME + '__headline' },
          htmlToReactParser.parse(headline.text)
        )
      )
    );
  }
  return null;
};

var renderHatchText = function renderHatchText(hatchText) {
  if (hatchText && hatchText.text) {
    return _react2.default.createElement(
      'p',
      { className: ORGANISM_NAME + '__hatch-text' },
      htmlToReactParser.parse(hatchText.text)
    );
  }
  return null;
};

var renderPrimaryCta = function renderPrimaryCta(primaryCta) {
  if (primaryCta && primaryCta.text) {
    var buttonClass = ORGANISM_NAME + '__btn';
    var targetValue = primaryCta.target || '_self';
    return _react2.default.createElement(
      _button2.default,
      {
        href: primaryCta.href,
        id: primaryCta.id,
        className: buttonClass,
        fpti: 'StepsAccrdn-PrmryCTA-' + primaryCta.text,
        target: targetValue
      },
      primaryCta.text
    );
  }
  return null;
};

var renderHr = function renderHr(show) {
  if (show) {
    return _react2.default.createElement(
      'div',
      { className: 'row ' + ORGANISM_NAME + '__hr' },
      _react2.default.createElement(
        'div',
        { className: 'col-md-12' },
        _react2.default.createElement('hr', null)
      )
    );
  }
  return null;
};

var renderStepsHeadline = function renderStepsHeadline(headline) {
  if (headline) {
    return _react2.default.createElement(
      _heading2.default,
      { level: '4', className: ORGANISM_NAME + '__head pp-sans-small-regular' },
      htmlToReactParser.parse(headline.text)
    );
  }
  return null;
};

var renderStepAccordion = function renderStepAccordion(steps) {
  if (steps) {
    return steps.map(function (elem, idx) {
      return _react2.default.createElement(
        _accordion.AccordionItem,
        { key: idx },
        _react2.default.createElement(
          _accordion.AccordionHeader,
          { idx: idx, className: ORGANISM_NAME + '__accordion__header' },
          _react2.default.createElement(
            'span',
            { className: ORGANISM_NAME + '__circle pp-sans-big-medium' },
            idx + 1
          ),
          renderStepsHeadline(elem.headline)
        ),
        _react2.default.createElement(
          _accordion.AccordionContent,
          { idx: idx },
          _react2.default.createElement(
            'p',
            { className: ORGANISM_NAME + '__text pp-sans-small-regular' },
            htmlToReactParser.parse(elem.paragraph.text)
          )
        )
      );
    });
  }
  return null;
};

var renderBelowSteps = function renderBelowSteps(primaryCta, hatchText) {
  if (primaryCta || hatchText) {
    return _react2.default.createElement(
      'div',
      { className: 'row ' + ORGANISM_NAME + '__cta-container' },
      renderPrimaryCta(primaryCta),
      renderHatchText(hatchText)
    );
  }
  return null;
};

var StepsAccordion = function (_React$Component) {
  _inherits(StepsAccordion, _React$Component);

  function StepsAccordion(props) {
    _classCallCheck(this, StepsAccordion);

    var _this = _possibleConstructorReturn(this, (StepsAccordion.__proto__ || Object.getPrototypeOf(StepsAccordion)).call(this, props));

    _this.state = {
      isMobile: false,
      showImages: false
    };

    _this.handleResize = _this.handleResize.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.handleOpenItem = _this.handleOpenItem.bind(_this);
    // adding references in case this component is extended
    _this.renderHeadline = renderHeadline;
    _this.renderHatchText = renderHatchText;
    _this.renderPrimaryCta = renderPrimaryCta;
    _this.renderHr = renderHr;
    _this.renderStepsHeadline = renderStepsHeadline;
    _this.renderStepAccordion = renderStepAccordion;
    _this.renderBelowSteps = renderBelowSteps;
    return _this;
  }

  _createClass(StepsAccordion, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var domRect = this.sectionElement ? this.sectionElement.getBoundingClientRect() : null;
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableImages();
        return;
      }
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'enableImages',
    value: function enableImages() {
      this.setState({
        showImages: true
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      window.removeEventListener('scroll', this.handleScroll);
      this.enableImages();
    }
  }, {
    key: 'handleResize',
    value: function handleResize(e) {
      // TODO: Explore different solution to trigger resize
      // inside an iFrame; We don't need this event
      // param; it's only for page-builder
      var newWindowWidth = e && e.iFrameWidth || window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (newWindowWidth < _breakpoints2.default.medium) {
        if (!this.state.isMobile) {
          this.setState({
            isMobile: true
          });
        }
      } else if (this.state.isMobile) {
        this.setState({
          isMobile: false
        });
      }
    }
  }, {
    key: 'handleOpenItem',
    value: function handleOpenItem(items) {
      if (this.props.onOpenItem) {
        this.props.onOpenItem(items);
      }

      this.forceUpdate();
    }
  }, {
    key: 'renderStepsImage',
    value: function renderStepsImage(idx, image) {
      var _props$config = this.props.config,
          showImages = _props$config.showImages,
          showArrows = _props$config.showArrows;


      var renderArrows = function renderArrows() {
        if (showArrows && idx) {
          return _react2.default.createElement('span', { className: ORGANISM_NAME + '__arrow' });
        }
        return null;
      };

      if (this.state.showImages && image && showImages && !this.state.isMobile) {
        return _react2.default.createElement(
          'div',
          { className: ORGANISM_NAME + '__image-wrapper' },
          renderArrows(idx),
          _react2.default.createElement('img', { alt: image.alt, src: image.src })
        );
      }
      return null;
    }
  }, {
    key: 'renderSteps',
    value: function renderSteps(steps) {
      var _this2 = this;

      if (steps) {
        // show accordion on mobile
        if (this.state.isMobile) {
          return _react2.default.createElement(
            _accordion.Accordion,
            { openItems: 0, onItemOpen: this.handleOpenItem },
            renderStepAccordion(steps)
          );
        }
        return steps.map(function (elem, idx) {
          return _react2.default.createElement(
            'div',
            {
              key: idx,
              className: 'col-md-4 col-sm-12 ' + ORGANISM_NAME + '__step ' + ORGANISM_NAME + '__step-' + idx
            },
            _this2.renderStepsImage(idx, elem.image),
            _react2.default.createElement(
              'span',
              { className: ORGANISM_NAME + '__circle' },
              idx + 1
            ),
            _react2.default.createElement(
              'div',
              { className: ORGANISM_NAME + '__content' },
              renderStepsHeadline(elem.headline),
              _react2.default.createElement(
                'p',
                { className: ORGANISM_NAME + '__text' },
                htmlToReactParser.parse(elem.paragraph.text)
              )
            )
          );
        });
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          content = _props.content,
          config = _props.config,
          className = _props.className;
      var headline = content.headline,
          hatchText = content.hatchText,
          steps = content.steps,
          primaryCta = content.primaryCta;


      var showImagesMod = _defineProperty({}, ORGANISM_NAME + '--show-images', config.showImages);

      var stepsClasses = (0, _classnames2.default)(ORGANISM_NAME, showImagesMod, config.theme, className);

      return _react2.default.createElement(
        'section',
        {
          className: stepsClasses,
          id: config.id ? config.id : null,
          'data-building-block': 'organism',
          ref: function ref(el) {
            _this3.sectionElement = el;
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          renderHeadline(headline),
          renderHr(!config.showImages && headline && !this.state.isMobile),
          _react2.default.createElement(
            'div',
            { className: 'row ' + ORGANISM_NAME + '__container' },
            this.renderSteps(steps)
          ),
          renderBelowSteps(primaryCta, hatchText)
        )
      );
    }
  }]);

  return StepsAccordion;
}(_react2.default.Component);

exports.default = StepsAccordion;


StepsAccordion.propTypes = {
  onOpenItem: _propTypes2.default.func,
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-white', 'theme-background-color-light']).isRequired,
    showImages: _propTypes2.default.bool,
    showArrows: _propTypes2.default.bool
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    steps: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      image: _propTypes2.default.shape({
        src: _propTypes2.default.string.isRequired
      }),
      headline: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired,
      paragraph: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired
    })).isRequired,
    primaryCta: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired,
      href: _propTypes2.default.string.isRequired,
      id: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  className: _propTypes2.default.string
};

StepsAccordion.defaultProps = {
  onOpenItem: function onOpenItem() {},
  config: {
    id: '',
    theme: 'theme-background-color-white',
    showImages: true,
    showArrows: true
  },
  content: {
    headline: {
      text: '34 characters maximum.'
    },
    steps: [{
      image: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/kui/organisms/steps-accordion/step1.png'
      },
      headline: {
        text: '30 characters maximum'
      },
      paragraph: {
        text: 'Fewer than 130 characters for paragraph text which ' + 'should equal less than 4 lines of text, sentence case, normal punctuation.'
      }
    }, {
      image: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/kui/organisms/steps-accordion/step1.png'
      },
      headline: {
        text: '30 characters maximum'
      },
      paragraph: {
        text: 'Fewer than 130 characters for paragraph text which ' + 'should equal less than 4 lines of text, sentence case, normal punctuation.'
      }
    }, {
      image: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/kui/organisms/steps-accordion/step1.png'
      },
      headline: {
        text: '30 characters maximum'
      },
      paragraph: {
        text: 'Fewer than 130 characters for paragraph text which ' + 'should equal less than 4 lines of text, sentence case, normal punctuation.'
      }
    }],
    primaryCta: {
      text: '29 characters maximum',
      href: '#',
      id: '',
      target: '_self'
    },
    hatchText: {
      text: '110 characters maximum for an optional Hatch Text ' + 'which appears below panels and can contain links.'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/steps-accordion/jsx/StepsAccordion.js
// module id = 1148
// module chunks = 4